import { PopperBase } from './popper-base';
import { LineOverOrdersPhase } from "../model";
import {
  PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE,
  PLANNER_SHOW_ORDERS_PHASE_TT,
  PLANNER_HIDE_ORDERS_PHASE_TT,
} from 'apps/events';
import PopperJS from 'popper.js';

class TooltipOrdersPhase extends PopperBase {
  init(){
    super.init();
    document.addEventListener(PLANNER_SHOW_ORDERS_PHASE_TT, (e) => this.showTooltip(e));
    document.addEventListener(PLANNER_HIDE_ORDERS_PHASE_TT, (e) => this.hideTooltip(e));
  }
  hideTooltip(e){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  showTooltip(e){
    let overOrdersPhase = e.detail.orders_planner.overOrdersPhase;
    this.isShow = true;
    let popper = new PopperJS(
      overOrdersPhase.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
  }
  onClose(){
    let e = new CustomEvent(PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE, {});
    document.dispatchEvent(e);
  }
}
let scope = 'orders.planner.dialog.tooltip-orders-phase';
riot.mixin(scope, TooltipOrdersPhase as riot.TagMixin);
